import { Box } from '@mui/material'
import { useCustomTheme } from 'contexts/theme'
import React, { PropsWithChildren } from 'react'
import { useStyles } from './styles'

const AuthenticationLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { theme } = useCustomTheme()
  const classes = useStyles()

  return (
    <>
      {children}

      {theme.name !== 'default' && (
        <Box className={classes.footerLogo}>
          <span>Powered By</span>{' '}
          <img
            src='/default/logo.svg'
            alt='powered logo'
          />
        </Box>
      )}
    </>
  )
}

export default AuthenticationLayout
